module.exports = __webpack_public_path__ + "slick-b7c9e1e479de3b53f1e4e30ebac2403a.woff";


//////////////////
// WEBPACK FOOTER
// ./~/slick-carousel/slick/fonts/slick.woff
// module id = 926
// module chunks = 124